import { useEffect } from 'react';
import { noop } from 'lodash';
import {
    OpenFibMigrationEventDetails,
    OpenFibMigrationEvent,
    removeEventHandler,
    setupEventHandler,
    DEPRECATED_EVENT_NAME,
} from '../UserMigration/fib-migration-trigger';
import { countEventTrigger } from '../../events/countEvent';
import { deprecatedLogger } from '../../utils';
import { MIGRATION_MODAL_EVENT_NAME, SeamlessModalPayloadValue } from './triggers';
import { ModalType } from './types';

const defaultModalProps: OpenFibMigrationEventDetails & { source?: string; isOpen?: boolean } = {
    source: 'default',
    withSkipAction: true,
    isOpen: false,
    redirectCtaData: undefined,
    onSuccess: noop,
    onError: noop,
    onLoadError: noop,
    onSkip: noop,
    biEnrichment: {} as OpenFibMigrationEventDetails['biEnrichment'],
};

/**
 * Handle "../UserMigration/fib-migration-trigger.ts" and "../SeamlessProMigrationModalManager/utils.ts"
 */
export const useOldModalMigrationEvents = ({
    setModalProps,
    setModalType,
}: {
    setModalProps(data: SeamlessModalPayloadValue): any;
    setModalType(type: ModalType): void;
}) => {
    // Listen legacy full user migration modal
    useEffect(() => {
        const handlePopupEvent = (event: OpenFibMigrationEvent) => {
            const {
                withSkipAction,
                redirectCtaData,
                onSuccess,
                onError,
                onSkip,
                onLoadError = noop,
                source,
                biEnrichment,
            } = event.detail || defaultModalProps;

            setModalType(ModalType.SeamlessUpgradeToPro);
            setModalProps({
                withSkipAction,
                onSuccess,
                onError,
                onSkip,
                onLoadError,
                source,
                isOpen: true,
                redirectCtaData,
                biEnrichment: { ...(biEnrichment as any) },
            } as any);

            countEventTrigger({ metric: 'legacy_modal_opened', type: 'full_migration' as ModalType, source });

            deprecatedLogger({
                componentName: `useOldModalMigrationEvents, window event: "${DEPRECATED_EVENT_NAME}"`,
                message: `Use openFipMigrationModal instead, or window event: "${MIGRATION_MODAL_EVENT_NAME}"`,
                source,
                withSkipAction,
                redirectCtaData,
                biEnrichment,
            });
        };
        setupEventHandler(handlePopupEvent);

        return () => {
            removeEventHandler(handlePopupEvent);
        };
    }, [setModalType, setModalProps]);
};
